<template>
  <div class="page-view">
    <snecmaSafran-registration v-if="isSnecmaSafranUser" portal="mycfm" />
    <geuser-registration v-else-if="geuser" portal="mycfm" />
    <nongeuser-registration v-else portal="mycfm" />
  </div>
</template>

<script>
import nongeuserRegistration from "@/mycfm/components/NonGeuserRegistration";
import geuserRegistration from "@/mycfm/components/GeuserRegistration";
import snecmaSafranRegistration from "@/mycfm/components/SnecmaSafranRegistration";
import { mapState } from "vuex";

export default {
  components: {
    geuserRegistration,
    nongeuserRegistration,
    snecmaSafranRegistration
  },
  computed: {
    ...mapState({
      geuser: state => state.user.user.geuser,
      isSnecmaSafranUser: state => {
        return (
          state.user.user.email.toLowerCase().endsWith("@safrangroup.com") ||
          state.user.user.email.toLowerCase().endsWith("@snecma.com")
        );
      }
    })
  }
};
</script>
<style scoped>
.page-view {
  margin-bottom: inherit;
}
</style>
